import {
  checkIfRested,
  RestedResult,
} from 'server/shared/helpers/eligibilityChecks';
import { Invitee } from 'server/shared/models/invitee';
import { InviteeStatusEnum } from 'server/shared/models/jobInviteeStatusEnum';
import { Shift } from 'server/shared/models/shift';
import { TranslationKeyTranslation } from 'server/shared/models/translation';
import { PoolerUser } from 'server/shared/models/user';
import { UserRestWarningTypeEnum } from 'server/shared/models/userRestWarning';

export function getJobRestWarning(
  jobData: {
    date: string;
    shifts: Shift[];
    jobId: string;
    invitees?: Invitee[];
  },
  user: PoolerUser,
  i18n: TranslationKeyTranslation,
): { restStatus: RestedResult; restWarning?: string } {
  const restStatus = checkIfRested({
    user,
    jobDate: jobData.date,
    jobShifts: jobData.shifts,
    currentJobId: jobData.jobId,
  });

  const invitee = jobData.invitees?.find(
    (invitee) => invitee.userId === user._id,
  );

  if (invitee && invitee.status === InviteeStatusEnum.TRANSFERRED) {
    restStatus.hasRested = true;
  }

  if (!restStatus.hasRested) {
    let restWarning = getRestWarningString(restStatus, i18n);
    return { restWarning, restStatus };
  } else {
    return { restStatus };
  }
}

export function getRestWarningString(
  restStatus: RestedResult,
  i18n: TranslationKeyTranslation,
): string {
  if (!restStatus.hasRested) {
    let restWarning = '';

    switch (restStatus.restType) {
      case UserRestWarningTypeEnum.ELEVEN_HOUR_WARNING:
        restWarning = i18n.elevenHourWarning;
        break;
      case UserRestWarningTypeEnum.SEVEN_DAY_WARNING:
        restWarning = i18n.sevenDayWarning;
        break;
      case UserRestWarningTypeEnum.POTENTIAL_SEVEN_DAY_WARNING:
        if (restStatus.withBreakInfraction) {
          restWarning = i18n.potentialSevenDayWarningWithInfraction;
        } else {
          restWarning = i18n.potentialSevenDayWarning;
        }
        break;
    }

    if (restStatus.startsWorkingAt) {
      restWarning += '\n';
      (restWarning +=
        ((i18n.nextShiftStart as string) || 'Nächste Schicht beginnt am: ') +
        restStatus.startsWorkingAt),
        +' ';
    }
    if (restStatus.workedUntil) {
      restWarning += '\n';
      restWarning +=
        ((i18n.lastShiftEnd as string) || 'Letzte Schicht endet am: ') +
        restStatus.workedUntil +
        ' ';
    }
    return restWarning;
  } else {
    return '';
  }
}
